module.exports = __webpack_public_path__ + "static/media/lotus.bc292d10.svg";